import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-enterprise';

@Component({
  selector: 'app-star-icon-cell-renderer',
  templateUrl: './star-icon-cell-renderer.component.html',
  styleUrls: ['./star-icon-cell-renderer.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class StarIconCellRendererComponent implements ICellRendererAngularComp {
  constructor() {}

  params!: ICellRendererParams;

  rating: number = 0;

  formatRating(params: ICellRendererParams) {
    this.params = params;

    const { data } = this.params;

    const { ['clientSpecificVendorRating']: rating } = data;

    if (rating) {
      const ratingFraction = rating - Math.floor(rating);

      if (ratingFraction < 0.75 && ratingFraction >= 0.25) {
        this.rating += Math.floor(rating) + 0.5;
      } else {
        this.rating = Math.round(rating);
      }
    }
  }

  agInit(params: ICellRendererParams<any, any, any>): void {
    this.formatRating(params);
  }

  refresh(params: ICellRendererParams) {
    this.formatRating(params);

    return true;
  }
}
